export default "__VITE_ASSET__BsgLljG1__"